export function hasTranslation(
  tFunction: (key: string) => string | undefined | null,
  key: string
): boolean {
  const translated = tFunction(key);
  return translated !== key && translated !== undefined && translated !== null;
}
